module.exports = __webpack_public_path__ + "front/img/u3.aa2a2af1.jpg";